var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12.3515 24.0485C11.8828 23.5799 11.8828 22.8201 12.3515 22.3515L18.7029 16L12.3515 9.64853C11.8828 9.17991 11.8828 8.42011 12.3515 7.95148C12.8201 7.48285 13.5799 7.48285 14.0485 7.95148L21.2485 15.1515C21.7172 15.6201 21.7172 16.3799 21.2485 16.8485L14.0485 24.0485C13.5799 24.5172 12.8201 24.5172 12.3515 24.0485Z","fill":"currentColor"}));
}

ArrowRight.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
